import {inject, Injectable} from '@angular/core';
import {NavigationExtras} from '@angular/router';
import {TBntRouterLinkInput} from '@binotel-frontend/bnt-common-components';
import {ERouterPages} from '@entities/router/router.enums';
import {Store} from '@ngrx/store';
import {RouterActions} from '@state/router/router.actions';
import {routerSelectors} from '@state/router/router.selectors';

type TRouterPath = (string | TBntRouterLinkInput<ERouterPages>)[];

@Injectable({providedIn: 'root'})
export class RouterFacade {
  private readonly store = inject(Store);

  public readonly $url = this.store.selectSignal(routerSelectors.selectUrl);
  public readonly $queryParams = this.store.selectSignal(
    routerSelectors.selectQueryParams
  );
  public go(
    path: TRouterPath,
    queryParams?: object,
    extras?: NavigationExtras
  ): void {
    this.store.dispatch(RouterActions.go({path, queryParams, extras}));
  }
}
